export default __webpack_public_path__ + "eeee6bfbda390d919b230b9af0d44e07.woff2";